module.exports = __webpack_public_path__ + "img/share-icon.0eddb3b0.svg";